type SettingsTextCardProps = {
    title: string
    description: string
    subtitle?: string
}

export const SettingsTextCard: React.FC<SettingsTextCardProps> = ({
    title,
    description,
    subtitle,
}) => {
    return (
        <div className="flex items-start justify-between rounded-lg border border-neutral-300 bg-white px-3 py-2 shadow-xs">
            <div className="grid gap-1">
                <div
                    className="text-label-small text-regular"
                    data-testid="settings-text-card-title"
                >
                    {title}
                </div>
                {subtitle && (
                    <div
                        className="text-body-small text-subtle"
                        data-testid="settings-text-card-subtitle"
                    >
                        {subtitle}
                    </div>
                )}
                <div
                    className="text-body-small text-subtle"
                    data-testid="settings-text-card-description"
                >
                    {description}
                </div>
            </div>
        </div>
    )
}
